/* eslint-disable-next-line no-restricted-imports */
import type { Id } from '@jane/shared/models';

import type {
  TargetedBrandSpecialProps,
  TargetedBrandSpecialsProps,
} from './targetedBrandSpecials.types';

export const targetedBrandSpecialsKeys = {
  brandSpecial: (params: TargetedBrandSpecialProps) => [
    'brandSpecials',
    params,
  ],
  brandSpecials: (params: TargetedBrandSpecialsProps) => [
    'brandSpecials',
    params,
  ],
  infiniteBrandSpecials: (params: { perPage: number; storeIds: Id[] }) => [
    'infiniteBrandSpecials',
    params,
  ],
};
